<app-crud-table [title]="'Lipids'" [columns]="columns" [filterFields]="filterFields"
  [crudAdapter]="crudAdapter"></app-crud-table>